import React, { ReactElement } from 'react'
import StepTitle from '../StepTitle'
import { IStepProps } from '../../interfaces/Step'
import Step3Form from './Step3Form'
import Step3Tooltip from '../tooltips/Step3Tooltip'
import TooltipWrapper from '../tooltips/TooltipWrapper'

function Step3(props: IStepProps): ReactElement {
  const { title } = props
  return (
    <>
      <StepTitle title={title}>
        <TooltipWrapper title="Pourquoi ces informations ?">
          <Step3Tooltip />
        </TooltipWrapper>
      </StepTitle>
      <p className="fontSizeXs mb1">
        Veuillez sélectionner le type de patrimoine et saisir le montant estimé
      </p>
      <Step3Form {...props} />
    </>
  )
}

export default Step3
